import { memo } from 'react';
import { ICommonTableHeadProps, UsersListTableHead } from 'components/cmn/CustomTableHeadWrapper';
import { ProjectUserContent } from 'interface/project/projectInfo';

function ManagementTableHead(props: ICommonTableHeadProps<ProjectUserContent>): JSX.Element {
  return <UsersListTableHead {...props} checkStyles={{ padding: '9px', marginLeft: '0px', marginRight: '0px' }} />;
}

export default memo(ManagementTableHead);
